import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useTranslate } from '@tolgee/react';

interface AddElementsProps {
  addSquareLogo?: () => void;
  addRectLogo?: () => void;
  addTitle?: () => void;
  addSecTitle?: () => void;
  addParagraph?: () => void;
}

const AddElementDropdown: React.FC<AddElementsProps> = ({
  addSquareLogo,
  addRectLogo,
  addTitle,
  addSecTitle,
  addParagraph
}) => {
  const { t } = useTranslate();
  const [show, setShow] = useState(false);

  return (
    <div className="dropdown">
      <button
        className="btn btn-light border rounded-2 p-2 dropdown-toggle d-flex align-items-center gap-1"
        type="button"
        id="dropdownMenuButtons"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          height: '40px'
        }}
        onClick={() => {
          console.log('it is clicked');
          setShow(!show);
        }}
      >
        <i
          style={{
            paddingRight: 0
          }}
          className="fas fa-plus"
        ></i>
        {t('lomavisCreator.overlayCreator.addElement')}
      </button>

      <div
        aria-labelledby="dropdownMenuButton"
        className={`dropdown-menu p-2 shadow ${show ? 'show' : ''}`}
      >
        <small className="text-muted px-2">
          {t('lomavisCreator.overlay.text')}
        </small>
        <button
          className="dropdown-item"
          onClick={() => {
            addTitle();
            setShow(!show);
          }}
        >
          <strong>{t('lomavisCreator.overlay.addTitle')}</strong>
        </button>
        <button
          className="dropdown-item"
          onClick={() => {
            addSecTitle();
            setShow(!show);
          }}
        >
          <strong>{t('lomavisCreator.overlay.addSecondaryTitle')}</strong>
        </button>
        <button
          className="dropdown-item"
          onClick={() => {
            addParagraph();
            setShow(!show);
          }}
        >
          {t('lomavisCreator.overlay.addParagraph')}
        </button>

        <div className="dropdown-divider"></div>

        <small className="text-muted px-2">
          {t('lomavisCreator.overlay.logo')}
        </small>
        <button
          className="dropdown-item"
          onClick={() => {
            addRectLogo();
            setShow(!show);
          }}
        >
          {t('lomavisCreator.overlay.rectangle')}
        </button>
        <button
          className="dropdown-item"
          onClick={() => {
            addSquareLogo();
            setShow(!show);
          }}
        >
          {t('lomavisCreator.overlay.square')}
        </button>
      </div>
    </div>
  );
};

export default AddElementDropdown;
